import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class AppErrorHandler extends ErrorHandler {

  handleError(error: any): void {
    // Send to Sentry without logging to console
    Sentry.captureException(error.originalError || error);
  }
}